import {
  ELEVATOR_PANE_LEFT_PADDING,
  MAP_PAGES_MAX_WIDTH,
  MAP_TITLE_HEIGHT_WITH_PADDING,
  OTHER_PAGES_SPACE_HEIGHT,
  useFloorMapSizer,
} from '@Map/FloorMap/FloorMapSizer';
import { useLayout } from '@react-native-community/hooks';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  pagesComponent: ReactNode;
  titleComponent: ReactNode;
  elevatorPanelComponent: ReactNode;
  closeButtonComponent: ReactNode;
};

export const MapLayoutLandscape = observer(function MapLayoutLandscape({
  pagesComponent,
  titleComponent,
  elevatorPanelComponent,
  closeButtonComponent,
}: Props) {
  const pagesBox = useLayout();
  const {
    pagesContainer,
    pagesMaxHeightLandscape: maxHeight,
    justifyContentLandscape: justifyContent,
    marginBottomLandscape: marginBottom,
    pagesMaxWidthLandscape: maxWidth,
    alignItemsLandscape: alignItems,
    elevatorWidthLandscape: width,
    titleMarginLeftLandscape: titleMarginLeft,
  } = useFloorMapSizer();

  useEffect(() => {
    pagesContainer.set({ height: pagesBox.height, width: pagesBox.width });
  }, [pagesBox.height, pagesBox.width]);

  return (
    <View style={[styles.alignmentWrapper, { justifyContent, alignItems }]}>
      <View
        style={[styles.mapPageWrapper, { maxHeight, marginBottom, maxWidth }]}
        onLayout={pagesBox.onLayout}
      >
        {pagesComponent}

        <View style={[styles.titleWrapper, { left: titleMarginLeft }]}>
          {titleComponent}
        </View>

        <View style={[styles.elevatorWrapper, { width, right: -width }]}>
          <View style={styles.closeButton}>{closeButtonComponent}</View>
          {elevatorPanelComponent}
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  alignmentWrapper: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
  },
  mapPageWrapper: {
    width: '100%',
    height: '100%',
    maxWidth: MAP_PAGES_MAX_WIDTH,
  },
  titleWrapper: {
    width: '100%',
    height: MAP_TITLE_HEIGHT_WITH_PADDING,
    position: 'absolute',
    top: -MAP_TITLE_HEIGHT_WITH_PADDING,
  },
  elevatorWrapper: {
    position: 'absolute',
    height: '100%',
    justifyContent: 'flex-end',
    paddingBottom: OTHER_PAGES_SPACE_HEIGHT * 2,
    paddingLeft: ELEVATOR_PANE_LEFT_PADDING,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    left: ELEVATOR_PANE_LEFT_PADDING,
  },
});
